// extracted by mini-css-extract-plugin
export default {"salesforce_chat_container":"styles_salesforce_chat_container__DPoh9","chat_icon":"styles_chat_icon__bDX7Z"};